export const ACTIVATION_FEATURE = 'campaign-manager:activation'
export const ACTIVATION_RESPONSiBLE_GAMBLING = 'campaign-manager:respgambling'
export const AVATAR_STUDIO_CATALOGUE = 'avatar-studio:catalogue'


